import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import ManagementAssignmentsPanel from '../../managementAssignmentsPanel/ManagementAssignmentsPanel'
import {isShown as isUserCreatePanelOpened} from '../../../../panels/user/createPanel/selectors'
import ManagementAssignmentsPanelContent from './ManagementAssignmentsPanelContent'
import {setEventPreventHidingEditUserSlidingPanel} from '../../../../panels/utils'
import {isNeedToLoadData, isShown, isLoading} from '../selectors'
import {loadData, closePanel} from '../actions'
import {cancelUserCreation} from '../../../../panels/user/createPanel/actions'

class CreateManagementAssignmentsPanel extends ManagementAssignmentsPanel {
    constructor(params) {
        const panelContent = new ManagementAssignmentsPanelContent({
            onBackButtonClick: () => this.params.onPanelHide(),
            onClickDialogContent: (e) => setEventPreventHidingEditUserSlidingPanel(e),
            onCloseButtonClick: () => params.closeAllPanels(),
        })
        super({
            ...params,
            additionalClass: 'createManagementAssignmentsPanel',
            panelContent: panelContent,
        })
    }
}

export default connect(
    state => ({
        userPanelOpenedBelow: isUserCreatePanelOpened(state),
        needToLoadData: isNeedToLoadData(state),
        isShown: isShown(state),
        loading: isLoading(state),
    }),
    dispatch => ({
        loadData: bindActionCreators(loadData, dispatch),
        onPanelHide: bindActionCreators(closePanel, dispatch),
        closeAllPanels: bindActionCreators(cancelUserCreation, dispatch),
    })
)(CreateManagementAssignmentsPanel)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createManagementAssignmentsPanel/components/ManagementAssignmentsPanel.js